import { Cache } from "aws-amplify";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import ClientDetails from "./ClientDetails";

function ClientDetailsForm(props) {
  const clientInfo = props.clientDetails;
  const [isLoading, setIsLoading] = useState(true);
  const SaveForm = (e) => {
    e?.preventDefault();
    props.saveData({...clientInfo, resultData: {...clientInfo.resultData, emailAddress: e.target.emailAddress.value}});
  };
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    if(props.handleNextState!==undefined){
      props.handleNextState(()=>SaveForm);
    }
  }, []);
  return (
    <>
    
      <form onSubmit={SaveForm}>
        <ClientDetails clientDetails={clientInfo} />
        <button type="submit" className="hidden" id="btnSubmit">
          submit
        </button>
      </form>
    </>
  );
}

export default ClientDetailsForm;
